import { eduIDApi } from "./common";
export const signupApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchState: builder.query({
            query: () => ({
                url: "state",
            }),
            extraOptions: { service: "signup" },
        }),
        getSignupCaptchaRequest: builder.query({
            query: () => ({
                url: "get-captcha",
                body: {},
            }),
            extraOptions: { service: "signup" },
        }),
        sendSignupCaptchaResponse: builder.query({
            query: (body) => ({
                url: "captcha",
                body,
            }),
            extraOptions: { service: "signup" },
        }),
        acceptToURequest: builder.query({
            query: (body) => ({
                url: "accept-tou",
                body: {
                    tou_accepted: true,
                    tou_version: body.version,
                },
            }),
            extraOptions: { service: "signup" },
        }),
        registerEmailRequest: builder.query({
            query: (body) => ({
                url: "register-email",
                body,
            }),
            extraOptions: { service: "signup" },
        }),
        verifyEmailRequest: builder.query({
            query: (body) => ({
                url: "verify-email",
                body,
            }),
            extraOptions: { service: "signup" },
        }),
        getPasswordRequest: builder.query({
            query: () => ({
                url: "get-password",
                body: {},
            }),
            extraOptions: { service: "signup" },
        }),
        createUserRequest: builder.query({
            query: (body) => ({
                url: "create-user",
                body: {
                    custom_password: body.custom_password,
                    use_suggested_password: Boolean(body.use_suggested_password),
                    use_webauthn: Boolean(body.use_webauthn),
                },
            }),
            extraOptions: { service: "signup" },
        }),
        startRegisterWebauthn: builder.query({
            query: (body) => ({
                url: "webauthn/register/begin",
                body,
            }),
            extraOptions: { service: "signup" },
        }),
        signupRegisterWebauthn: builder.query({
            query: (body) => ({
                url: "webauthn/register/complete",
                body: {
                    response: body.webauthn_attestation,
                    description: body.description,
                    clientExtensionResults: body.clientExtensionResults,
                },
            }),
            extraOptions: { service: "signup" },
        }),
        signupReturnToAuthn: builder.query({
            query: (body) => ({
                url: "return-to-auth",
                body: {
                    ref: body.ref,
                },
            }),
            extraOptions: { service: "signup" },
        }),
        externalMfaRegister: builder.query({
            query: (body) => ({
                url: "external-mfa-register",
                body,
            }),
            extraOptions: { service: "signup" },
        }),
        externalMfaClear: builder.query({
            query: () => ({
                url: "external-mfa-clear",
                body: {},
            }),
            extraOptions: { service: "signup" },
        }),
    }),
});
export default signupApi;
